import React from "react";
import Grid from "@mui/material/Grid";

// import information from "../../../assets/images/icons/infoIcon.png";
// import probLegendIcon from "../../../assets/images/icons/sticky-notes.png";
// import ProbScoreLegend from "../ProbabilityScoreLegend/ProbScoreLegend";

import "./styles/DashboardHeader.scss";

// import { Height, Padding } from "@mui/icons-material";
// import styles from './DashboardHeader.module.css'; // Importing the CSS module

/**
 * The `DashboardHeader` component displays the header section of the dashboard page.
 * It includes legends for data visualization.
 *
 * This function is called in src\Component\Dashboard\Dashboard.jsx
 *
 * @param {boolean} displayProbScore - Indicates whether to display the probability score legend.
 * @returns {JSX.Element} The rendered `DashboardHeader` component.
 */
const DashboardHeader = ({
  displayProbScore,
}) => {
  return (
    <>

      {/* filterby- sortby */}

      {/*         <div className="flex-item-two">
          {displayProbScore === true && (
            <div className="probability-score-legend-image">
              <Popover
                // placement= "left"
                showArrow={false} //experimental
                //trigger="click"
                content={<ProbScoreLegend />}
              >
                <img //searched important icon
                  src={probLegendIcon}
                  alt="Probability score tooltip"
                />
              </Popover>
            </div>
          )}
        </div> */}
      {/* </div> */}
    </>
  );
};

export default DashboardHeader;
